import { useEffect, useState, useRef } from "react";
import { SavedResourceSchema, SearchFilterOptionType, ResourceType } from "../../../data/types";
// import { ReactComponent as OrderIcon } from '../../icons/OrderIcon.svg'
import SavedResourceCard from "../../../components/Mobile/SavedResourceCard";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
// import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import Pagination from "../../../components/Mobile/Pagination";
import { usePagination } from "../../../hooks/paginationhooks";

// import BookedResourceCard from "../../components/BookedResourceCard";
import {
  useCompleteSignIn,
  // useLoadBookings,
  useUpdateAccountDetails,
} from "../../../hooks/authhooks";
import { useLoadResourcesFilter, useLoadResourceOptions, useLoadSavedResources } from "../../../hooks/apphooks";
// import { BookingDetailsModal } from '../../../molecules/Mobile/AppModal';


type SavedResourceListingProps = {
  searchFilterOptions: SearchFilterOptionType
}

const SavedResourceListing: React.FC<SavedResourceListingProps> = ({ searchFilterOptions }) => {
  const { user } = useCompleteSignIn();
  const { searchTerm, currentFilter } = searchFilterOptions;
  const { allOptions } = useLoadResourceOptions();
  
  // Filter dropdown states
  const [statusFilter, setStatusFilter] = useState<'all' | 'active' | 'inactive'>('all');
  const [resourceTypeFilter, setResourceTypeFilter] = useState<ResourceType | 'all'>('all');
  const [isStatusDropdownOpen, setIsStatusDropdownOpen] = useState(false);
  const [isResourceTypeDropdownOpen, setIsResourceTypeDropdownOpen] = useState(false);
  const statusDropdownRef = useRef<HTMLDivElement>(null);
  const resourceTypeDropdownRef = useRef<HTMLDivElement>(null);

  // Get saved resources from user object
  const rawSavedResources: SavedResourceSchema[] =
    user && user?.saved_resources ? user.saved_resources : [];
  
  // Fetch full resource details for saved resources to ensure complete data
  const { enrichedSavedResources: allSavedResources, isLoading: isLoadingSavedResources } = useLoadSavedResources(rawSavedResources);
  
  // const [filterSetting, setFilterSetting] = useState<boolean>(false);
  // const [currentSavedResourcePage, setCurrentSavedResourcePage] = useState(1);

  // Filter by state (existing filter)
  var filteredSavedResources = allSavedResources
    ? allSavedResources.filter(
        (resource) =>
          resource?.state?.toLowerCase() ===
            currentFilter.state.toLowerCase() ||
          resource?.state === "" ||
          currentFilter.state === ""
      )
    : [];

  // Filter by status (active/inactive)
  if (statusFilter === 'active') {
    filteredSavedResources = filteredSavedResources.filter(
      (resource) => resource?.active === true
    );
  } else if (statusFilter === 'inactive') {
    filteredSavedResources = filteredSavedResources.filter(
      (resource) => resource?.active === false
    );
  }

  // Filter by resource type
  if (resourceTypeFilter !== 'all') {
    filteredSavedResources = filteredSavedResources.filter(
      (resource) => resource?.resource_type === resourceTypeFilter
    );
  }


  var { searchSavedResources } = useLoadResourcesFilter(
    "kitchen",
    currentFilter.state,
    currentFilter.active
  );

  if (searchTerm) {
    const { searchedResources } = searchSavedResources(searchTerm, filteredSavedResources);
    filteredSavedResources = searchedResources;
  }

  const {
    currentPage,
    setCurrentPage,
    paginatedItems: paginatedResources,
    startIndex,
    endIndex,
    totalItems: numSavedResources,
    itemsPerPage
  } = usePagination(filteredSavedResources);

  useEffect(() => {
    document.title = `HomeCook | Saved Resources Listing`;
  }, []);

  // Close dropdowns when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (statusDropdownRef.current && !statusDropdownRef.current.contains(event.target as Node)) {
        setIsStatusDropdownOpen(false);
      }
      if (resourceTypeDropdownRef.current && !resourceTypeDropdownRef.current.contains(event.target as Node)) {
        setIsResourceTypeDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // const loggedin_username = user?.username ? user?.username : "";
  const loggedinUid = user?.uid ? user?.uid : "";
  const { removeResource } = useUpdateAccountDetails(loggedinUid);

  const handleRemoveSavedResource = (resource_id: string | undefined) => {
    if (resource_id) {
      removeResource(resource_id);
    }
  };

  const getStatusDisplayText = () => {
    switch (statusFilter) {
      case 'active':
        return 'Active';
      case 'inactive':
        return 'Inactive';
      default:
        return 'All Statuses';
    }
  };

  const getResourceTypeDisplayText = () => {
    if (resourceTypeFilter === 'all') {
      return 'All Resources';
    }
    const option = allOptions.find((opt) => opt.path === resourceTypeFilter);
    if (!option) return 'All Resources';
    
    // Use shorter names for display in the button
    const shortNames: { [key: string]: string } = {
      'kitchen': 'Kitchen Spaces',
      'documentation': 'Documentation',
      'training': 'Training',
      'funding': 'Funding',
      'expert': 'Experts',
      'farm': 'Fresh Food'
    };
    
    return shortNames[resourceTypeFilter] || option.name;
  };

  // var { bookings } = useLoadBookings(loggedin_username);
  // bookings = bookings ? bookings : [];


  // const {
  //   currentPage: bookingsCurrentPage,
  //   setCurrentPage: setBookingsCurrentPage,
  //   paginatedItems: paginatedBookings,
  //   startIndex: bookingsStartIndex,
  //   endIndex: bookingsEndIndex,
  //   totalItems: numBookings,
  //   itemsPerPage: bookingsPerPage
  // } = usePagination(bookings);

  // type savedResourcePageOptionsType = {
  //   id: "saved" | "booked"
  //   name: string;
  // }
  // const savedResourcePageOptions: savedResourcePageOptionsType[] = [
  //   {
  //     id: "saved",
  //     name: `Saved (${allSavedResources.length})`,
  //   },
  //   {
  //     id: "booked",
  //     name: `Bookings and Reservations (${bookings.length})`,
  //   },
  // ];

  // const [currentOption, setCurrentOption] = useState("saved");
  // const resourcesPerPage = 6;
  // var startIndex = 0;
  // var endIndex =
  //   numSavedResources <= resourcesPerPage
  //     ? numSavedResources
  //     : resourcesPerPage;
  // var numPages = Math.ceil(numSavedResources / resourcesPerPage);

  // Add state for modal
  // const [isBookingModalOpen, setIsBookingModalOpen] = useState(false);
  // const [selectedBooking, setSelectedBooking] = useState<ResourceBookingSchema | null>(null);
  // const [isEditMode, setIsEditMode] = useState(false);

  // const handleViewDetails = (booking: ResourceBookingSchema) => {
  //   setSelectedBooking(booking);
  //   setIsEditMode(false);
  //   setIsBookingModalOpen(true);
  // };

  // const handleEditDetails = (booking: ResourceBookingSchema) => {
  //   setSelectedBooking(booking);
  //   setIsEditMode(true);
  //   setIsBookingModalOpen(true);
  // };

  // const handleCloseBookingModal = () => {
  //   setIsBookingModalOpen(false);
  //   setSelectedBooking(null);
  //   setIsEditMode(false);
  // };

  return (
    <>
      <div
        className={`w-full left-0 flex font-open-sans h-full overflow-y-scroll relative  top-0 justify-center bg-gradient-to-b from-[#F5F5F5] pb-6  backdrop-blur-2xl bg-[#fff]`}
      >
        
        <div
          className={`flex flex-col  w-full h-${
            allSavedResources && allSavedResources.length
              ? `[1348px]`
              : `full`
          } overflow-y-scroll relative items-start  bg-white`}
        >
          <div className="flex flex-col  p-5 sm:h-screen w-full bg-[#FFFFFF] rounded-xl  ">
            <h1 className="font-bold text-2xl">Saved Resources</h1>
            
            {/* Filter Dropdowns */}
            <div className="flex flex-row gap-4  mt-4 mb-4">
              {/* Status Filter Dropdown */}
              <div className="relative flex-1" ref={statusDropdownRef}>
                <button
                  onClick={() => {
                    setIsStatusDropdownOpen(!isStatusDropdownOpen);
                    setIsResourceTypeDropdownOpen(false);
                  }}
                  className="w-full flex flex-row items-center justify-between px-4 py-3 bg-white border border-[#E9E9E9] rounded-lg text-left font-raleway text-sm text-[#4D4D4D] hover:border-[#5DB6CE] transition-colors"
                >
                  <span>{getStatusDisplayText()}</span>
                  <KeyboardArrowDownIcon 
                    className={`w-5 h-5 text-[#4D4D4D] transition-transform ${isStatusDropdownOpen ? 'rotate-180' : ''}`}
                  />
                </button>
                {isStatusDropdownOpen && (
                  <div className="absolute z-10 w-full mt-1 bg-white border border-[#E9E9E9] rounded-lg shadow-lg">
                    <button
                      onClick={() => {
                        setStatusFilter('all');
                        setIsStatusDropdownOpen(false);
                      }}
                      className={`w-full text-left border-0 px-4 py-2 text-sm font-raleway hover:bg-[#F5F5F5] ${
                        statusFilter === 'all' ? 'bg-[#E7F5EC] text-[#0F973D]' : 'text-[#4D4D4D]'
                      }`}
                    >
                      All Statuses
                    </button>
                    <button
                      onClick={() => {
                        setStatusFilter('active');
                        setIsStatusDropdownOpen(false);
                      }}
                      className={`w-full text-left border-0 px-4 py-2 text-sm font-raleway hover:bg-[#F5F5F5] ${
                        statusFilter === 'active' ? 'bg-[#E7F5EC] text-[#0F973D]' : 'text-[#4D4D4D]'
                      }`}
                    >
                      Active
                    </button>
                    <button
                      onClick={() => {
                        setStatusFilter('inactive');
                        setIsStatusDropdownOpen(false);
                      }}
                      className={`w-full text-left border-0 px-4 py-2 text-sm font-raleway hover:bg-[#F5F5F5] rounded-b-lg ${
                        statusFilter === 'inactive' ? 'bg-[#E7F5EC] text-[#0F973D]' : 'text-[#4D4D4D]'
                      }`}
                    >
                      Inactive
                    </button>
                  </div>
                )}
              </div>

              {/* Resource Type Filter Dropdown */}
              <div className="relative flex-1" ref={resourceTypeDropdownRef}>
                <button
                  onClick={() => {
                    setIsResourceTypeDropdownOpen(!isResourceTypeDropdownOpen);
                    setIsStatusDropdownOpen(false);
                  }}
                  className="w-full flex flex-row items-center justify-between px-4 py-3 bg-white border border-[#E9E9E9] rounded-lg text-left font-raleway text-sm text-[#4D4D4D] hover:border-[#5DB6CE] transition-colors"
                >
                  <span className="truncate">{getResourceTypeDisplayText()}</span>
                  <KeyboardArrowDownIcon 
                    className={`w-5 h-5 text-[#4D4D4D] transition-transform flex-shrink-0 ml-2 ${isResourceTypeDropdownOpen ? 'rotate-180' : ''}`}
                  />
                </button>
                {isResourceTypeDropdownOpen && (
                  <div className="absolute z-10 w-full mt-1 bg-white border border-[#E9E9E9] rounded-lg shadow-lg max-h-60 overflow-y-auto">
                    <button
                      onClick={() => {
                        setResourceTypeFilter('all');
                        setIsResourceTypeDropdownOpen(false);
                      }}
                      className={`w-full text-left border-0 px-4 py-2 text-sm font-raleway hover:bg-[#F5F5F5] ${
                        resourceTypeFilter === 'all' ? 'bg-[#E7F5EC] text-[#0F973D]' : 'text-[#4D4D4D]'
                      }`}
                    >
                      All Resources
                    </button>
                    {allOptions.map((option) => (
                      <button
                        key={option.path}
                        onClick={() => {
                          setResourceTypeFilter(option.path);
                          setIsResourceTypeDropdownOpen(false);
                        }}
                        className={`w-full text-left border-0 px-4 py-2 text-sm font-raleway hover:bg-[#F5F5F5] ${
                          resourceTypeFilter === option.path ? 'bg-[#E7F5EC] text-[#0F973D]' : 'text-[#4D4D4D]'
                        }`}
                      >
                        {option.name}
                      </button>
                    ))}
                  </div>
                )}
              </div>
            </div>

           
            {isLoadingSavedResources ? (
              <div className="flex flex-row justify-evenly font-light text-center text-[#013847]/60 text-xs sm:text-sm py-8">
                Loading saved resources...
              </div>
            ) : paginatedResources && paginatedResources.length > 0 ? (
              paginatedResources.map(
                (resource: SavedResourceSchema, i: number) => (
                  <SavedResourceCard
                    key={resource.resource_id || resource.id || i}
                    isMobile={true}
                    resource={resource}
                    handleRemoveSavedResource={handleRemoveSavedResource}
                  />
                )
              )
            ) : (
              <div className="flex flex-row justify-evenly font-light text-center text-[#013847]/60 text-xs sm:text-sm">
                No saved resources to show
              </div>
            )}
          </div>
          {filteredSavedResources && (
              <Pagination
                currentPage={currentPage}
                totalItems={numSavedResources}
                startIndex={startIndex}
                endIndex={endIndex}
                onPageChange={setCurrentPage}
                itemsPerPage={itemsPerPage}
              />
            )}
        </div>
      </div>
    </>
  );
};

export default SavedResourceListing;
